import { useClickstreamAnalytics, ITrackType } from '../clickstream-analytics-context';
import { referrerMapper } from './util/referrer-mapper';
import { uisMicroMessagesAggregator } from './util';
export var useClickTracker = function () {
    var track = useClickstreamAnalytics().track;
    return function (referrerId, linkName, delay, additionalUisPrimeMicroMessages) {
        track(ITrackType.EVENT, {
            data: uisMicroMessagesAggregator(referrerMapper(referrerId, linkName), additionalUisPrimeMicroMessages),
            config: { delay: delay }
        });
    };
};
//# sourceMappingURL=use-click-tracker.js.map